import ChatsRowItem from '../ChatsList/ChatsRowItem';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import ChatsSearch from '../../common/ChatsSearch';
import { SvgIcon } from '@/components/UI/Common/SvgIcon';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
import { useState } from 'react';
import cn from 'classnames';

const pluralMembers = (n: number): string => {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 19) return `${n} участников`;
  if (mod10 === 1) return `${n} участник`;
  if (mod10 >= 2 && mod10 <= 4) return `${n} участника`;
  return `${n} участников`;
};

const ChatsContentHeader = ({
  iconSrc,
  title,
  type,
  usersAmount,
  onSearch,
  onFocus,
}: {
  title?: string;
  type?: 'personal' | 'public';
  usersAmount?: number | null;
  iconSrc?: string;
  onSearch?: (value: string) => void;
  onFocus?: () => void;
}) => {
  const { isMobile } = useBreakpoints();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const hideChatInfo = isMobile && isSearchOpen;

  return (
    <ChatsRowItem
      id="chats-content-header"
      className="z-10 flex h-[80px] shrink-0 items-center gap-3 bg-white px-8 md:h-14 md:gap-2.5 md:px-5"
    >
      <Link to={ROUTES.CHATS.BASE} className="shrink-0 md:hidden">
        <SvgIcon name="arrow-back" />
      </Link>

      <div
        className={cn(
          'flex min-w-0 items-center gap-3 overflow-hidden transition-all duration-200 ease-out md:gap-2.5',
          hideChatInfo
            ? 'max-w-0 opacity-0 -translate-x-2 pointer-events-none'
            : 'flex-1 opacity-100 translate-x-0',
        )}
      >
        <img
          className="h-12 w-12 shrink-0 rounded-full object-cover md:h-9 md:w-9"
          src={iconSrc}
          alt=""
        />
        <div className="flex min-w-0 flex-1 flex-col gap-1 md:gap-0.5">
          <h3 className="truncate font-medium md:text-base">{title}</h3>
          {type === 'public' && usersAmount !== undefined && (
            <p className="truncate text-sm text-lightGray md:text-xs">
              {pluralMembers(usersAmount ?? 0)}
            </p>
          )}
        </div>
      </div>

      <ChatsSearch onSearch={onSearch} onFocus={onFocus} onOpenChange={setIsSearchOpen} />
    </ChatsRowItem>
  );
};

export default ChatsContentHeader;
